import { Injectable, OnInit, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "../components/dialog/error-dialog/error-dialog.component";
import { TranslateHelper } from "../utils/translate-helper";
import { SessionStorageService } from "./session-storage.service";
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "./dialog.service";
import HwUtil from "../utils/hw-util";

@Injectable({ providedIn: 'root' })
export class ErrorService {
    private sessionStorageService = inject(SessionStorageService);
    private dialogservice = inject(DialogService);
    private translateService = inject(TranslateService);

    async ngOnInit() {
        const urlParamsFromSessionStorage = this.sessionStorageService.getUrlParams();
    }

    showErrorText(error: string, title?: string): any {
        return this.showErrors([error], title);
    }

    showError(error: any, title?: string): any {
        if (error.status === 0) {
            return this.showErrorText(this.translateService.instant("errors.ERR_NO_SERVICE"), title);
        } else if (error.status === 500 || error.status === 409) {
            return this.showErrorText(error.error.detail ?? this.translateService.instant("errors.ERR_UNKNOWN_ERROR"), title);
        }

        if (error.error.errors)
            return this.showErrors(error.error.errors.map(x => x.propertyName ? `${HwUtil.getShortPropertyName(x.propertyName)}: ${x.message}` : x.message), title);
    }

    showErrors(errors: string[], title?: string): any {
        return this.dialogservice.showError(errors, title);
    }
}

